import React, { useState, useEffect, Fragment } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next'
import Host from '../../Components/Host';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import HelmetComponent from '../../Components/HelmetComponent';

function AboutUs() {

  const { t } = useTranslation()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, [])

  return (
    <>
      <HelmetComponent title={'About Us'} />
      <div className="statisc-page">

        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div className="static-container-card"
                style={{ textAlign: 'left', padding: '20px', background: '#fcfcfc', border: '1px solid #eee', borderRadius: '7px' }}>
                <h1 style={{ padding: '20px 0px 20px 0px', fontWeight: 300, fontSize: '1.4rem' }}>
                  {t('about_us')}
                </h1>
                <p>At RockMyCart, our mission is simple: make online shopping exciting again.</p>
                <p>We’re building a UAE-based shopping website delivering all over GCC. Where customers can discover great products, rock-solid deals, and categories that cover everything from electronics and gadgets to fashion, home and lifestyle.</p>
                <p>Because shopping shouldn’t be boring.</p>
                <p>It should rock.</p>
                <p>Shopping That Rocks</p>
               
                <br /><br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;

